import { render } from "./SurveyTable.vue?vue&type=template&id=85404138&ts=true"
import script from "./SurveyTable.vue?vue&type=script&lang=ts"
export * from "./SurveyTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Surveys/SurveyTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85404138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85404138', __exports__)) {
    api.reload('85404138', __exports__)
  }
  
  module.hot.accept("./SurveyTable.vue?vue&type=template&id=85404138&ts=true", () => {
    api.rerender('85404138', render)
  })

}


export default __exports__